import script from "./competencies.vue?vue&type=script&setup=true&lang=js"
export * from "./competencies.vue?vue&type=script&setup=true&lang=js"

import "./competencies.vue?vue&type=style&index=0&id=987fb8e8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-987fb8e8"]])

export default __exports__